"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _CollapseItemBody = _interopRequireDefault(require("./CollapseItemBody.style"));
var _Collapse = require("../Collapse");
var _excluded = ["children", "classPrefix"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var CollapseItemBody = function CollapseItemBody(_ref) {
  var children = _ref.children,
    classPrefix = _ref.classPrefix,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement(_CollapseItemBody["default"], _extends({
    className: "".concat(classPrefix, "Body")
  }, otherProps), children);
};
CollapseItemBody.propTypes = {
  /** The html class name */
  classPrefix: _propTypes["default"].string,
  children: _propTypes["default"].node.isRequired
};
CollapseItemBody.defaultProps = {
  classPrefix: _Collapse.COLLAPSE_ROOT_CLASS_NAME
};
var _default = exports["default"] = CollapseItemBody;